import { SVGProps } from 'react';

const Download = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 15V3m5 7-5 5-5-5m14 5v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
    />
  </svg>
);
export default Download;
